<template>
  <div class="notice_wrap" v-loading="loading">
   	<div class="notice_cont">
   		<div class="top_head">
   			<li>通知列表<span>({{noticeList.length}})</span></li>
   			<div class="ipt" v-if="userType == 0 || userType == 1">
   				<el-select v-model="pushStatus" placeholder="请选择" @change="pushStatusChange">
				    <el-option
				      v-for="item in options"
				      :key="item.value"
				      :label="item.label"
				      :value="item.value">
				    </el-option>
				  </el-select>
				  <el-input v-model="titleCont" @keyup.enter.native="searchList()" placeholder="请输入标题"></el-input>
					<el-button @click="searchList()">查询</el-button>
					<el-button class="add_notice" @click="addNotice()">添加</el-button>
   			</div>
   		</div>
   		<div class="notice_list" :style="'height:'+height">
   			<ul v-if="noticeList.length">
   				<li class="list_item" v-for="(item,index) in noticeList" :key="index" v-if="userType == 0 || userType == 1">
   					<div class="top_list">
							<div class="name_status"><b v-if="item.top == 1">【置顶】</b><span>开课通知</span><i :class="item.ispush == 1 ? 'blur':'grey'">{{handleStatus(item.ispush)}}</i></div>
							<div class="dataTime">{{item.createtime.slice(0,10)}}</div>
						</div>
						<p class="content" @click="toDetail(item)">{{item.title}}</p>
						<div class="bottom" v-if="item.classNums == 0">
							<a v-if="item.ispush == 0" @click="editNotice(item)">编辑</a>
							<a v-if="item.ispush == 0" @click="releases(item)">发布</a>
							<a v-if="item.ispush == 1" @click="noRelease(item)">取消发布</a>
							<a @click="deleteNotice(item)">删除</a>
						</div>
   				</li>
   				<li class="list_item" v-for="(item,index) in noticeList" :key="index" v-if="userType == 2 || userType == 3">
   					<div class="top_list">
							<div class="name_status"><b v-if="item.top == 1">【置顶】</b><span>开课通知</span></div>
							<div :class="item.readstatus == 0?'red':'black'">{{item.readstatus == 0? '未读':'已读'}}</div>
						</div>
						<p class="content" @click="toDetail(item)">{{item.title}}</p>
						<div class="bottom_name">
							<span>来自老师：{{item.sendername}}</span>
							<span>{{item.createtime.slice(0,10)}}</span>
						</div>
   				</li>
   			</ul>
   			<div v-else class="no_list">
	        <img src="../../../../../../static/images/wujieguo.png"/>
	        <p>暂无通知</p>
	      </div>
   			<pagination
	        :currentpage="pageTotal.currentPage"
	        :pageSize="pageTotal.pageSize"
	        :total="pageTotal.total"
	        layout="prev, pager, next, jumper"
	        v-on:currentPageFn="currentPageFn"
	        :current-page.sync="pageTotal.currentPage"
	        v-if="noticeList.length && (pageTotal.total>pageTotal.pageSize)"
	      ></pagination>
   		</div>
   	</div>
   	<!--添加课程通知-->
		<el-drawer
		  title="添加通知详情"
		  :visible.sync="drawer"
		  :direction="direction"
		  :close-on-press-escape="false"
		  :wrapperClosable="false"
		  :modal="false"
		  :with-header="false">
		  <div class="drawer_content">
		  	<header>
		  		<span>{{titleTop}}</span><img @click="close()" src="../../../../../../static/images/close.png"/>
		  	</header>
		  	<div class="content_into" :style="'height:'+drawerHeight">
		  		<div class="ipt">
			  		<p>标题：</p>
			  		<el-input v-model.trim="title" placeholder="请输入标题" maxlength="30"></el-input>
			  	</div>
			  	<div class="ipt">
			  		<p>内容：</p>
			  		<v-editor v-model="noticeContent" class="notice_content"></v-editor>
			  	</div>
			  	<div class="ipt">
			  		<span class="ipt_label">是否置顶：</span>
			  		<el-radio-group v-model="topping" :disabled="indexNum>=5?true:false">
					    <el-radio :label="1">置顶</el-radio>
					    <el-radio :label="0">不置顶</el-radio>
					  </el-radio-group>
					  <span class="topNum" v-if="indexNum>=5">最多置顶5条哦！</span>
			  	</div>
			  	<div class="ipt">
			  		<span class="ipt_label">状态：</span>
			  		<el-radio-group v-model="release">
					    <el-radio :label="1">发布</el-radio>
					    <el-radio :label="0">不发布</el-radio>
					  </el-radio-group>
			  	</div>
			  	<div class="btn">
			  		<el-button @click="close()">取消</el-button>
						<el-button type="primary" @click="save()">保存</el-button>
			  	</div>
		  	</div>
		  </div>
		</el-drawer>
   	<!--课程通知详情-->
   	<el-drawer
		  title="课程通知详情"
		  :visible.sync="drawerDetail"
		  :direction="direction"
		  :close-on-press-escape="false"
		  :wrapperClosable="false"
		  :with-header="false"
		  :modal="false"
		  class="drawerDetail">
		  <div class="drawer_detail">
		  	<header>
		  		<span>课程通知详情</span><img @click="closeDetail()" src="../../../../../../static/images/close.png"/>
		  	</header>
		  	<div class="content_into" :style="'height:'+drawerHeight">
		  		<div class="cont">
		  			<h3>{{detailObj.title}}</h3>
		  			<p class="dataTime">{{detailObj.timeData}}</p>
		  			<p class="date_cont" v-html="detailObj.msgcontent"></p>
		  		</div>
		  	</div>
		  </div>
		</el-drawer>
  </div>
</template>
<script>
	import * as api from "../../../../../api/individualApi";
	import Pagination from "../../../../paginator/paginator.vue";
	import vEditor from "@/components/wjlEditor/index.vue";
	export default {
		components:{
	    vEditor,
	    Pagination
	  },
		data(){
			return {
				height: window.innerHeight - 160+"px",
				drawerHeight:window.innerHeight - 86+'px',
				options: [{
					label: '全部',
          value: ''
        }, {
        	label: '已发布',
          value: '1'
        }, {
        	label: '未发布',
          value: '0'
        }],
        pushStatus: '',
        titleCont: '',
        userType: sessionStorage.getItem('userType'),
        pageTotal: {
	        currentPage: 1,
	        pageSize: 10,
	        total: 0
	      },
	      noticeList:[],
	      loading: true,
	      detailObj: {},
	      drawerDetail: false,
	      direction: 'rtl',
	      drawer: false,
	      noticeId:'',
	      titleTop:'',
	      title:'',
	      noticeContent: '',
	      topping: 1,
	      release: 1,
	      indexNum: 0
			}
		},
		created(){
			this.getNoticeList();
		},
		methods: {
			// 获取课程通知列表
			getNoticeList(){
				this.indexNum = 0;
				let obj = {
					"classId": this.$route.query.classId,
					"courseId": this.$route.query.id,
					"pageNum": this.pageTotal.currentPage,
					"pageSize": this.pageTotal.pageSize,
					"param": this.titleCont,
					"pushStatus": this.pushStatus
				};
				let request
				if(this.userType == 0 || this.userType == 1){
					request = api.getNoticeList(obj);
				}else if(this.userType == 2 || this.userType == 3){
					request = api.getNoticeStudentList(obj);
				}
				request.then(res=>{
					console.log(res);
					this.loading = false
					if(res.code == 0){
						this.noticeList = res.data.list;
						this.pageTotal.total = res.data.total;
						this.noticeList.forEach(val=>{
							if(val.top == 1){
								this.indexNum++;
							}
						})
					}else{
						this.$messageError(res.msg);
					}
				})
			},
			// 保存
			save(){
				if(!this.title){
					this.$messageError('请填写标题');
					return;
				}
				if(!this.noticeContent){
					this.$messageError('请填写内容');
					return;
				}
				let newArr = [];
				newArr.push(this.$route.query.classId);
				if(this.titleTop == '编辑通知'){
					let obj = {
						id:this.noticeId,
						classIds:newArr,
						courseId:this.$route.query.id,
						ispush:this.release,
						msgcontent:this.noticeContent,
						title:this.title,
						top:this.topping,
						objecttype:1
					};
					api.updateNotice(obj).then(res=>{
						if(res.code == 0){
							this.drawer = false;
							this.getNoticeList();
							this.$messageSuccess('修改成功');
						}else{
							this.$messageError(res.msg);
						}
					}).catch(error => {});
				}else if(this.titleTop == '添加通知'){
					let obj = {
						classIds:newArr,
						courseId:this.$route.query.id,
						ispush:this.release,
						msgcontent:this.noticeContent,
						title:this.title,
						top:this.topping,
						objecttype:1
					};
					api.addNotice(obj).then(res=>{
						if(res.code == 0){
							this.drawer = false;
							this.getNoticeList();
							this.$messageSuccess('添加成功');
						}else{
							this.$messageError(res.msg);
						}
					}).catch(error => {});
				}
			},
			// 查询
			searchList(){
				this.pageTotal.currentPage = 1;
				this.getNoticeList();
			},
			pushStatusChange(val){
				this.pushStatus = val;
				this.getNoticeList();
			},
			// 添加打开课程通知
			addNotice(){
				this.drawer = true;
				this.release = 1;
				this.noticeContent = '';
				this.title = '';
				this.indexNum>=5?this.topping=0:this.topping=1
				this.titleTop = '添加通知'
			},
			// 编辑打开课程通知
			editNotice(item){
				this.drawer = true;
				this.titleTop = '编辑通知';
				this.title = item.title;
				this.noticeContent = item.msgcontent;
				this.topping = item.top;
				this.release = item.ispush;
				this.noticeId = item.id;
			},
			// 直接发布
	   	releases(item){
	   		let obj = {
	   			id: item.id,
					ispush: 1,
					objecttype:1
				};
				api.updateNotice(obj).then(res=>{
					if(res.code == 0){
						this.getNoticeList();
						this.$messageSuccess('发布成功');
					}else{
						this.$messageError(res.msg);
					}
				}).catch(error => {});
	   	},
	   	// 直接取消发布
	   	noRelease(item){
	   		let obj = {
	   			id: item.id,
					ispush: 0,
					objecttype:1
				};
				api.updateNotice(obj).then(res=>{
					if(res.code == 0){
						this.getNoticeList();
						this.$messageSuccess('取消发布成功');
					}else{
						this.$messageError(res.msg);
					}
				}).catch(error => {});
	   	},
			// 删除通知
			deleteNotice(item){
				this.$tipsDialog(
					"提示",
      		"确定删除该通知吗？",
			    "",
			    "el-icon-warning",
			    "rgb(255, 178, 60)"
				).then(() => {
					api.delNotice(item.id).then(res=>{
						if(res.code == 0){
							this.getNoticeList();
							this.$messageSuccess('删除成功');
						}
					}).catch(error => {});
       	}).catch(() => {});
			},
			// 查看详情
      toDetail(item){
      	this.drawerDetail = true;
      	this.detailObj = item;
      	this.detailObj.timeData = this.detailObj.createtime.substring(0,10);
      },
      // 关闭添加编辑通知
      close(){
      	this.drawer = false;
      },
      // 关闭详情
      closeDetail(){
      	if(this.userType == 0 || this.userType == 1){
      		this.drawerDetail = false;
      	}else if(this.userType == 2 || this.userType == 3){
      		api.studentNoticeRead(this.detailObj.id).then(res=>{
	      		if(res.code == 0){
	      			this.drawerDetail = false;
	      			this.getNoticeList();
	      		}
	      	})
      	}
      },
			// 处理状态
			handleStatus(val){
				let str = '';
				switch (val){
					case 0:
						str = '未发布'
						break;
					case 1:
						str = '已发布'
						break;
					default:
						break;
				}
				return str
			}
		}
	}
</script>
<style lang="scss" scoped>
	.notice_wrap {
		padding: 16px;
		height: 100%;
		background: #F4F4F4;
		padding-bottom: 0;
		/deep/ .drawerDetail {
			.el-drawer {
				width: 40% !important;
			}
		}
		.notice_cont {
			padding: 0 20px;
			background: #fff;
			.top_head {
				display: flex;
				align-items: center;
				justify-content: space-between;
				height: 50px;
				border-bottom: 1px solid #E6E6E6;
				li {
					span {
						color: #F00000;
						margin-left: 5px;
					}
				}
				.ipt {
					display: flex;
					justify-content: space-between;
					align-items: center;
					.el-input,.el-select {
						width: 180px;
						margin-right: 10px;
						/deep/ .el-input__inner {
							height: 30px;
							line-height: 30px;
						}
						/deep/ .el-input__icon {
							line-height: 30px;
						}
					}
					/deep/ .el-button {
						padding: 7px 21px;
						span {
							font-size: 12px;
							color: #5397F7;
						}
					}
				}
				li {
					position: relative;
					font-size: 16px;
					color: #333333;
					&::after {
						position: absolute;
						content: '';
						width: 64px;
						height: 1px;
						background: #333333;
						top: 33px;
						left: 0;
					}
				}
			}
			.notice_list {
				margin-top: 16px;
				overflow-y: auto;
				ul {
					.list_item {
						height: 109px;
						border: 1px solid #E6E6E6;
						margin-bottom: 12px;
						padding: 15px 16px 8px 16px;
						border-radius:4px 4px 0px 0px;
						.top_list {
							display: flex;
							justify-content: space-between;
							.name_status {
								span {
									font-size: 16px;
									color: #333333;
								}
								i {
									display: inline-block;
									width:60px;
									height:20px;
									background:rgba(83,151,247,1);
									text-align: center;
									line-height: 20px;
									color: #fff;
									font-size: 12px;
									margin-left: 18px;
								}
								.grey {
									background:rgba(153,160,170,1);
								}
								.blur {
									background:rgba(83,151,247,1);
								}
								b {
									font-style: normal;
									font-size: 14px;
									color: #F77981;
									margin-left: -6px;
								}
							}
							.red {
								font-size: 14px;
								color: #F43D3D;
							}
							.black {
								font-size: 14px;
								color: #999999;
							}
							.dataTime {
								font-size: 12px;
								color: #666666;
							}
						}
						.content {
							font-size: 12px;
							color: #333333;
							margin: 10px 0;
							overflow: hidden;
							display: -webkit-box;
							-webkit-line-clamp: 2;
							-webkit-box-orient: vertical;
							line-height: 20px;
							cursor: pointer;
							min-height: 42px;
						}
						.bottom {
							display: flex;
							justify-content: flex-end;
							a {
								display: inline-block;
								padding: 0 12px;
								height:24px;
								border:1px solid rgba(228,232,241,1);
								border-radius:12px;
								line-height: 24px;
								text-align: center;
								color: #5397F7;
								font-size: 12px;
								margin-left: 16px;
								cursor: pointer;
							}
						}
						.bottom_name {
							display: flex;
							justify-content: space-between;
							span {
								color: #999999;
								font-size: 12px;
							}
						}
					}
				}
				.no_list{
		      padding-top: 100px;
		      text-align: center;
		      p{
		        margin-top: 10px;
		        color: #666;
		      }
		    }
			}
		}
		/deep/ .el-drawer {
			width: 60% !important;
		}
		.drawer_content,.drawer_detail {
			.content_into {
				overflow-y: auto;
			}
			header {
				display: flex;
				justify-content: space-between;
				align-items: center;
				height: 64px;
				border-bottom: 2px solid #DDE0E2;
				padding: 0 20px;
				span {
					font-size: 16px;
					color: #0D141E;
				}
				img {
					display: block;
					width: 26px;
					height: 26px;
					cursor: pointer;
				}
			}
			.ipt {
				padding: 0 16px;
				margin-top: 16px;
				p {
					font-size: 12px;
					margin-bottom: 12px;
				}
				.topNum {
					font-size: 14px;
					color: red;
				}
				/deep/ .el-input {
					.el-input__inner {
						height: 42px;
						line-height: 42px;
						border: 0;
						background: #F1F2F4;
						border-radius: 4px;
					}
				}
				.notice_content {
					clear: both;
				}
				.transfer {
					.left {
						width: 100%;
					}
					.left {
						>.el-checkbox {
							margin-bottom: 6px;
							margin-left: 12px;
							/deep/ .el-checkbox__label {
								font-size: 12px;
							}
						}
					}
					.checkbox {
						height: 162px;
						background: #F1F2F4;
						border-radius: 4px;
						/*overflow-y: auto;*/
						.el-checkbox-group {
							height: 150px;
							padding: 12px;
							display: flex;
					    flex-flow: column;
					    flex-wrap: wrap;
							.el-checkbox {
								margin-bottom: 10px;
								/deep/ .el-checkbox__label {
									font-size: 12px;
								}
							}
						}
					}
				}
				.ipt_label {
					display: inline-block;
					width: 64px;
					text-align: right;
					font-size: 12px;
					color: #0D0D0D;
				}
			}
			.btn {
				text-align: center;
				margin-top: 10%;
				margin-bottom: 30px;
				.el-button {
					padding: 7px 23px;
					margin-left: 0;
					margin-right: 15px;
				}
			}
		}
		.drawer_detail {
			.content_into {
				padding: 10px 20px;
				p.classNames {
					font-size: 12px;
					color: #0D141E;
					margin-top: 22px;
				}
				.cont {
					h3,.dataTime {
						text-align: center;
					}
					h3 {
						color: #0D141E;
						font-size: 16px;
						margin-bottom: 10px;
					}
					.dataTime {
						color: #858C96;
						margin-bottom: 26px;
					}
					.date_cont {
						font-size: 14px;
						color: #5D646E;
						line-height: 20px;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/notice/index.vue